// Rebuilds a cart plan from a historical order against the CURRENT menu.
// Canonical ids win; names are only a fallback for orders saved before option ids were stored.
export function planReorder(order, products) {
  const byId = Object.fromEntries((products || []).map((p) => [p.id, p]));
  const plan = [];
  let skipped = 0;
  let optionIssues = 0;

  for (const it of order.items || []) {
    const p = byId[it.product_id];
    if (!p || p.available === false) { skipped++; continue; }
    const all = [
      ...(p.modifier_groups || []).flatMap((g) => g.options || []),
      ...(p.extras || []),
    ];
    const ids = [];
    for (const m of it.modifiers || []) {
      const o = all.find((x) => (m.id && x.id === m.id) || x.name === m.name);
      if (o && o.available !== false) ids.push(o.id);
      else optionIssues++;
    }
    // Required groups must still be satisfied; otherwise the item needs a manual review.
    const unmet = (p.modifier_groups || []).some((g) => g.required && !(g.options || []).some((o) => ids.includes(o.id)));
    if (unmet) { optionIssues++; continue; }
    plan.push({ product: p, ids, qty: it.quantity, note: it.note || "", person: it.person_label || "" });
  }
  return { plan, skipped, optionIssues };
}
